import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { UtilsService } from 'app/modules/utils-service';
import { forkJoin, Observable } from 'rxjs';
import { SolicitudesService } from '../solicitudes/solicitudes.service';
import { GestionesService } from './gestiones.service';
import { UserService } from 'app/core/user/user.service';

@Injectable({ providedIn: 'root' })
export class GestionesResolver implements Resolve<any> {
    
    constructor(
            private _gestionesService:GestionesService,
            private _utilsService: UtilsService,
            private _userService:UserService
        ){}
    
    resolve(route: ActivatedRouteSnapshot): Observable<any> {
        const seccion_uuid = route.paramMap.get('seccion_uuid');
        const user_id = parseInt(this._userService.usuarioLogueadoValues.user_id);
        
        const routePath = route.routeConfig?.path;
        const esRutaGeneral = routePath?.includes('generales');
        this._utilsService.esRutaGenerales = esRutaGeneral;
    
        if (seccion_uuid) {
            this._utilsService.seccion_uuid = parseInt(seccion_uuid);
        } else {
            this._utilsService.seccion_uuid = null;
        }

        const paginacion = {
            inicio: 0,
            max: 10
        };
    
        const params = { usuarioAsignado: user_id, inicio:0, max:10};
        const _params = { seccion: seccion_uuid, inicio:0, max:10};

        const paramsTotalesSeccion= {seccion: seccion_uuid}
        const paramsTotalesUsuarioAsignado= { usuarioAsignado: user_id,}
    
        if (seccion_uuid) {
            this._gestionesService.setGestionesFilterParams = _params
            return forkJoin([
                this._gestionesService.getAllTasks(_params),
                this._gestionesService.getTotalesGestiones(paramsTotalesSeccion)
                
            ]);
        } else if (esRutaGeneral) {//En la ruta general no se envian parametros
             this._gestionesService.setGestionesFilterParams =paginacion
            return forkJoin([
                this._gestionesService.getAllTasks(paginacion),
                this._gestionesService.getTotalesGestiones()
            ]);
        } else {
            this._gestionesService.setGestionesFilterParams =params
            return forkJoin([
                this._gestionesService.getAllTasks(params),
                this._gestionesService.getTotalesGestiones(paramsTotalesUsuarioAsignado)
            ]);
        }
    }
     
}